/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */

import { Box, Button } from '@mui/material';
import React, { useContext, useState } from 'react';

import { VALID_QUERY_HELPERS } from '../constants';
import { ElasticDslEntitlementContext } from './ElasticDslEntitlementContext';
import { DslOperator } from './interface';

interface IElasticDslOperatorProps {
  focusTextField: () => void;
  disabled: boolean;
}

export const ElasticDslOperators = ({ focusTextField, disabled }: IElasticDslOperatorProps) => {
  const { addOperator } = useContext(ElasticDslEntitlementContext);
  const [buttonVariants] = useState<DslOperator[]>(VALID_QUERY_HELPERS);

  return (
    <Box display="flex" columnGap={1}>
      {buttonVariants.map((operator) => {
        return (
          <Button
            disabled={disabled}
            key={operator.toString()}
            variant="outlined"
            onClick={(event) => {
              event.preventDefault();
              addOperator(operator);
              focusTextField();
            }}
          >
            {operator}
          </Button>
        );
      })}
    </Box>
  );
};
